import { render } from "./NewCityComponent.vue?vue&type=template&id=144525f6"
import script from "./NewCityComponent.vue?vue&type=script&lang=js"
export * from "./NewCityComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__